module.exports = __webpack_public_path__ + "img/descargar.00994624.svg";